export default __webpack_public_path__ + "static/media/hand-sample.8960cfa9.png";